@if (historyGridColumns; as columns) {
  <ellf-data-grid
    [items]="items"
    [hideCommands]="true"
    [gridOptions]="historyGridOptions"
    [columnDefs]="columns"
    [rowSelection]="'single'"
    [selectedItems]="selectedHistoryEntity ? [selectedHistoryEntity] : []"
    (selected)="onSelectionChange($event)"
    >
  </ellf-data-grid>
}
